import { ValidateJSModel, ListModel } from 'forms/shared/types';
import { ValidateJSLengthBaseValidatorOptions } from 'forms/shared/types/validatejs/length.d.ts';
import branchModelValidator from '../branch';

const listModelValidator: ValidateJSModel<ListModel<unknown>> = {
  branch: {
    model: {
      validator: branchModelValidator,
    },
  },
  items: (value, attributes, attributeName, options) => {
    const { length = {} } = options;
    const {
      minimum = 1,
      tooShort = 'error.list.length.min',
    } = length as ValidateJSLengthBaseValidatorOptions;

    return {
      length: {
        minimum,
        tooShort,
      },
    };
  },
};

export default listModelValidator;
